import { AxiosResponse } from 'axios';
import { MapedProfessionsType, ParsedProfession, Profession } from './utils';

export enum ProfessionsStatusEnum {
  EVENT_PROFESSIONS = 'professions/get',
  EVENT_PROFESSION = 'profession/get',
  EVENT_PROFESSIONS_MINI = 'professions/mini',
}

export interface GetProfession {
  data: Profession;
}

export interface PromiseProfessions {
  data: MapedProfessionsType;
  filtered?: number;
}

export interface PromiseProfession {
  data: ParsedProfession;
}

export interface ProfessionMini {
  id: string | number;
  name: string;
}

export type ProfessionsMini = AxiosResponse<ProfessionMini>;



// WEBPACK FOOTER //
// ./src/services/api/professions/types.ts